<template>
  <div v-if="isIncoming" :class="errorClass">
    <div class="error-content">
      <img :src="currentImage" alt="" />
      <span class="error-text">{{ subTitle }}</span>
    </div>
  </div>

  <div v-else :class="errorClass">
    <div class="error-content">
      <img :src="currentImageBlue" alt="" />
      <span class="error-text">{{ subTitle }}</span>
    </div>
  </div>
</template>
<script>
import imageOff from '../../../../assets/images/image-off.png';
import imageOffBlue from '../../../../assets/images/image-off-blue.png';
import videoOff from '../../../../assets/images/video-off.png';
import videoOffBlue from '../../../../assets/images/video-off-blue.png';
import audioOff from '../../../../assets/images/audio-off.png';

export default {
  name: 'Unavailable',
  props: {
    isIncoming: {
      type: Boolean,
      default: false,
    },
    subTitle: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'image',
      validator: value => ['image', 'video', 'audio'].includes(value),
    },
    isPrivate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageOff,
      imageOffBlue,
      videoOff,
      videoOffBlue,
      audioOff,
      audioOffBlue: audioOff,
    };
  },
  computed: {
    // Regresa la imagen correspondiente según el tipo de mensaje
    currentImage() {
      return this.type === 'video'
        ? this.videoOff
        : this.type === 'audio'
        ? this.audioOff
        : this.imageOff;
    },
    // Regresa la imagen correspondiente en azul según el tipo de mensaje
    currentImageBlue() {
      return this.type === 'video'
        ? this.videoOffBlue
        : this.type === 'audio'
        ? this.audioOffBlue
        : this.imageOffBlue;
    },
    // Retorna las clases CSS según el tipo de mensaje
    errorClass() {
      const baseClass = this.isIncoming
        ? 'incoming-error-placeholder'
        : 'outgoing-error-placeholder';
      const classes =
        this.type === 'audio' ? [baseClass, 'error-audio'] : [baseClass];

      if (this.isPrivate) {
        classes.push('is-private-error-placeholder');
      }

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
.outgoing-error-placeholder {
  width: 32rem;
  height: 20rem;
  background-color: var(--conversa2-blue-100-color);
  border-radius: var(--border-radius-normal);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 12px 0 var(--conversa2-blue-200-color);
}

.incoming-error-placeholder {
  width: 32rem;
  height: 20rem;
  background-color: var(--conversa2-neutral-50-color);
  border-radius: var(--border-radius-normal);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 12px 0 var(--conversa2-neutral-100-color);
}

.error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-small);
}

.error-text {
  color: var(--conversa2-neutral-800-color);
  font-size: var(--font-size-small);
}

.error-audio {
  width: auto;
  height: 4rem;
  padding: var(--space-smaller) var(--space-small);
  box-shadow: none;

  .error-content {
    flex-direction: row;
    gap: var(--space-smaller);

    img {
      padding-right: 0.6rem;
    }
  }
}

.incoming-error-placeholder.error-audio {
  border: solid 1px var(--conversa2-neutral-200-color);
}
.outgoing-error-placeholder.error-audio {
  border: solid 1px var(--conversa2-blue-200-color);
}

.is-private-error-placeholder {
  background-color: var(--conversa2-orange-50-color);
  box-shadow: none;
  border: none !important;
}
</style>
